import { render, staticRenderFns } from "./AddSubCategory.vue?vue&type=template&id=5013c1fa&scoped=true&"
import script from "./AddSubCategory.vue?vue&type=script&lang=js&"
export * from "./AddSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddSubCategory.vue?vue&type=style&index=0&id=5013c1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013c1fa",
  null
  
)

export default component.exports